export default __webpack_public_path__ + "static/media/Group1497-Yono2.5ac4b43e.png";